import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { LogOut, Menu, X, Home } from 'lucide-react';
import { Button } from './ui/button';
import { useState } from 'react';

export const Layout = ({ children, title }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getHomeUrl = () => {
    if (!user) return '/login';
    const roleMap = { super_admin: '/admin/super', tenant_admin: '/admin/tenant', content_admin: '/admin/content', institution_admin: '/admin/institution', student: '/student' };
    return roleMap[user.role] || '/login';
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-14 sm:h-16">
            <div className="flex items-center gap-2 sm:gap-4 min-w-0">
              <button onClick={() => navigate(getHomeUrl())} className="flex-shrink-0" data-testid="nav-home-btn">
                <img
                  src="https://customer-assets.emergentagent.com/job_e147f8d8-c7cf-461e-90dc-648b43a5b2be/artifacts/d0j1yj5f_AR%20Smart%20Books%20Logo%20Transparent.png"
                  alt="AR Smart Books"
                  className="h-8 sm:h-10 w-auto"
                />
              </button>
              {title && (
                <span className="text-xs sm:text-sm text-slate-500 truncate">/ {title}</span>
              )}
            </div>
            <div className="flex items-center gap-2 sm:gap-4">
              {user && (
                <>
                  <div className="text-right hidden sm:block">
                    <p className="text-sm font-medium text-slate-900">{user.name}</p>
                    <p className="text-xs text-slate-500 capitalize">{user.role.replace('_', ' ')}</p>
                  </div>
                  <Button
                    data-testid="logout-btn"
                    variant="ghost"
                    size="sm"
                    onClick={handleLogout}
                    className="rounded-full hover:bg-indigo-50"
                  >
                    <LogOut className="w-4 h-4" />
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-7xl mx-auto w-full px-3 sm:px-6 lg:px-8 py-4 sm:py-8">
        {children}
      </main>
      <footer className="border-t border-slate-200 bg-white mt-auto">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
            <div className="flex items-center gap-2">
              <img
                src="https://customer-assets.emergentagent.com/job_e147f8d8-c7cf-461e-90dc-648b43a5b2be/artifacts/d0j1yj5f_AR%20Smart%20Books%20Logo%20Transparent.png"
                alt="AR Smart Books"
                className="h-6 sm:h-8 w-auto"
              />
              <span className="text-xs sm:text-sm text-slate-600 font-medium">Transforming Textbooks into 3D</span>
            </div>
            <p className="text-xs sm:text-sm text-slate-500">Developed by <span className="font-medium text-slate-700">Any Tech Ventures Pvt. Ltd.</span></p>
          </div>
        </div>
      </footer>
    </div>
  );
};
